(function ($) {
  var $postContainer = $("#post-excerpts-container");

  if ($postContainer.length > 0) {
    var pageNumber = 1;
    var pageType = $postContainer.data("post-type");
    var exclude = $postContainer.data("exclude") || null;

    var initialPostsCount = $(".archive-column").length;
    if ($(".hero--news").length) {
      initialPostsCount += 1;
    }
    var initialMaxPostsCount = parseInt($("#total-resources").text());
    $("#currently-shown").text(initialPostsCount);
    calculateBarLength(
      $("#archive-count-bar-indicator"),
      initialPostsCount,
      initialMaxPostsCount,
      $("#archive-load-more")
    );

    $(document).on("click", "#archive-load-more", function (event) {
      event.preventDefault();
      load_posts();
    });

    /** We only want to autoload these posts if the container exists on the page - otherwise it's an intensive call */
    load_posts();
  }

  function load_posts() {
    $.ajax({
      url: ajaxpagination.ajaxurl,
      type: "POST",
      data: {
        action: "more_post_ajax",
        pageNumber: pageNumber,
        page_id: ajaxpagination.page_id,
        page_type: pageType,
        exclude: exclude,
      },
      beforeSend: function () {
        $(".archive-load-more .lds-dual-ring").show();
      },
      success: function (html) {
        var $postExcerptsContainer = $("#post-excerpts-container");

        $postExcerptsContainer.append(html);
        var countPosts = $postExcerptsContainer.find(".archive-column").length;
        var maxPosts = parseInt($("#total-resources").text());

        $("#currently-shown").text(countPosts);
        calculateBarLength(
          $("#archive-count-bar-indicator"),
          countPosts,
          maxPosts,
          $("#archive-load-more")
        );
        pageNumber++;
      },
      complete: function () {
        $(".archive-load-more .lds-dual-ring").hide();
      },
      fail: function () {
        $("#post-excerpts-container").append(
          '<p class="text-center">No more posts to load.</p>'
        );
      },
    });
  }

  function lastExcerptPosition() {
    var target = $(".archive-column");
    if (target.length) {
      var scrollTo =
        target.last().offset().top + target.last().outerHeight(true);
      $("html, body").animate({ scrollTop: scrollTo }, "slow");
    }
  }

  function calculateBarLength(target, current, max, button) {
    var lengthPercentage = Math.round((current / max) * 100);
    target.css("width", lengthPercentage + "%");
    if (current == max) {
      disableTarget(button);
    }
  }

  function disableTarget(target) {
    target.prop("disabled", true);
  }
})(jQuery);
